<template>
  <div class="mbti-selection-page">
    <!-- 头部 -->
    <PageHeader 
      :current-page="currentPage" 
      :islogin="islogin"
      :active-side="activeSide"
      :avatar="avatar"
      :nickname="nickname"
      @switch-side="handleSwitch"
      @logout="handleLogout"
      @show-feedback="goToFeedback"
    />

    <div class="page-layout">
      <!-- 左侧边栏（展开状态） -->
      <aside v-if="!isSidebarCollapsed" class="sidebar">
        <div class="sidebar-content">
          <!-- 职业顾问信息 -->
          <div class="consultant-section">
            <div class="consultant-avatar">
              <div class="avatar-img" v-if="consultantAvatar">
                <img :src="consultantAvatar" :alt="consultantName">
              </div>
              <div class="avatar-placeholder" v-else>
                {{ consultantName.charAt(0) }}
              </div>
              <div class="consultant-info">
                <div class="consultant-label">您的职业顾问</div>
                <div class="consultant-name">{{ consultantName }}</div>
              </div>
              <div class="consultant-icon">
                <img src="./assets/img/close.png" alt="close" class="consultant-icon-img" @click="toggleSidebar"/>
              </div>
            </div>
          </div>
          <div class="nav-divider"></div>

          <!-- 新对话按钮 -->
          <button class="new-chat-btn new-chat" @click="handleNewChat">
            <span class="btn-icon">+</span>
            <span class="btn-text">新对话</span>
          </button>


          <!-- 折叠面板：我的收藏和历史对话 -->
          <el-collapse 
            v-model="activeCollapse" 
            class="sidebar-collapse"
            @change="handleCollapseChange"
          >
            <el-collapse-item name="favorites" title="我的收藏">
              <template slot="title">
                <span class="collapse-title">
                  <span>我的收藏</span>
                  <i class="el-icon-star-off icon"></i>
                </span>
              </template>
              <div class="collapse-list">
                <div
                  v-for="(item, index) in favoritesList"
                  :key="index"
                  :class="['collapse-list-item', { 'is-active': isFavoriteItemActive(item) }]"
                  @click="handleFavoriteClick(item)"
                >
                  <span class="list-item-text">{{ item.title }}</span>
                  <span class="list-item-time">{{ item.time }}</span>
                </div>
                <div v-if="favoritesList.length === 0 && !favoritesLoading" class="collapse-empty">
                  暂无收藏
                </div>
                <div v-if="favoritesHasMore" class="load-more-wrapper">
                  <button 
                    class="load-more-btn" 
                    :disabled="favoritesLoading"
                    @click="loadMoreFavorites"
                  >
                    {{ favoritesLoading ? '加载中...' : '加载更多' }}
                  </button>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="history" title="历史对话">
              <template slot="title">
                <span class="collapse-title">
                  <span>历史对话</span>
                  <i class="el-icon-time icon"></i>
                </span>
              </template>
              <div class="collapse-list">
                <div
                  v-for="(item) in historyList"
                  :key="item.session_id"
                  :class="['collapse-list-item', { 'is-active': isHistoryItemActive(item) }]"
                  @click="handleHistoryClick(item)"
                >
                  <span class="list-item-text">{{ item.title }}</span>
                  <span class="list-item-time">{{ item.create_time }}</span>
                </div>
                <div v-if="historyList.length === 0 && !historyLoading" class="collapse-empty">
                  暂无历史对话
                </div>
                <div v-if="historyHasMore" class="load-more-wrapper">
                  <button 
                    class="load-more-btn" 
                    :disabled="historyLoading"
                    @click="loadMoreHistory"
                  >
                    {{ historyLoading ? '加载中...' : '加载更多' }}
                  </button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </aside>

      <!-- 收缩状态左侧窄条 + 抽屉入口 -->
      <div
        v-else-if="isSidebarCollapsed"
        :class="['collapsed-strip', { 'is-chat-step': currentStep === 3 }]"
        @mouseenter="handleCollapsedEnter"
        @mouseleave="handleCollapsedLeave"
      >
        <div class="collapsed-buttons">
          <!-- 展开侧边栏按钮 -->
          <div
            class="collapsed-icon"
            @click.stop.prevent="handleCollapsedIconClick"
            @mousedown.stop.prevent="handleCollapsedMouseDown"
            @mouseenter.stop="handleIconEnter"
            @mouseleave.stop="handleIconLeave"
          >
            <img
              src="./assets/img/close.png"
              alt="close"
              class="consultant-icon-img"
            />
          </div>
        </div>
        <button class="new-chat-btn" @click="handleNewChat">
          <span class="btn-icon">+</span>
          <span class="btn-text">新对话</span>
        </button>
      </div>

      <!-- 收缩时的悬浮侧边，用 Element UI 抽屉实现 -->
      <el-drawer
        :visible="drawerVisible"
        direction="ltr"
        :with-header="false"
        :modal="false"
        :append-to-body="true"
        custom-class="mbti-mini-drawer"
        size="180px"
        @mouseenter.native="handleDrawerEnter"
        @mouseleave.native="handleDrawerLeave"
        @close="drawerVisible = false"
      >
        <div
          class="sidebar-content mini"
        >

          <!-- 折叠面板：我的收藏和历史对话 -->
          <el-collapse 
            v-model="activeCollapse" 
            class="sidebar-collapse"
            @change="handleCollapseChange"
          >
            <el-collapse-item name="favorites" title="我的收藏">
              <template slot="title">
                <span class="collapse-title">
                  <span>我的收藏</span>
                  <i class="el-icon-star-off icon"></i>
                </span>
              </template>
              <div class="collapse-list">
                <div
                  v-for="(item, index) in favoritesList"
                  :key="index"
                  :class="['collapse-list-item', { 'is-active': isFavoriteItemActive(item) }]"
                  @click="handleFavoriteClick(item)"
                >
                  <span class="list-item-text">{{ item.title }}</span>
                  <span class="list-item-time">{{ item.time }}</span>
                </div>
                <div v-if="favoritesList.length === 0 && !favoritesLoading" class="collapse-empty">
                  暂无收藏
                </div>
                <div v-if="favoritesHasMore" class="load-more-wrapper">
                  <button 
                    class="load-more-btn" 
                    :disabled="favoritesLoading"
                    @click="loadMoreFavorites"
                  >
                    {{ favoritesLoading ? '加载中...' : '加载更多' }}
                  </button>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="history" title="历史对话">
              <template slot="title">
                <span class="collapse-title">
                  <span>历史对话</span>
                  <i class="el-icon-time icon"></i>
                </span>
              </template>
              <div class="collapse-list">
                <div
                  v-for="(item, index) in historyList"
                  :key="index"
                  :class="['collapse-list-item', { 'is-active': isHistoryItemActive(item) }]"
                  @click="handleHistoryClick(item)"
                >
                  <span class="list-item-text">{{ item.title }}</span>
                  <span class="list-item-time">{{ item.time }}</span>
                </div>
                <div v-if="historyList.length === 0 && !historyLoading" class="collapse-empty">
                  暂无历史对话
                </div>
                <div v-if="historyHasMore" class="load-more-wrapper">
                  <button 
                    class="load-more-btn" 
                    :disabled="historyLoading"
                    @click="loadMoreHistory"
                  >
                    {{ historyLoading ? '加载中...' : '加载更多' }}
                  </button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>

      <!-- 内容区域 -->
      <main class="main-content" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
        <!-- 步骤内容区域 -->
        <div class="step-content">
          <!-- 步骤0: 欢迎页 -->
          <WelcomePage
            v-if="currentStep === 0"
            :username="nickname"
            @next="currentStep = 1"
            @skip="handleWelcomeSkip"
            @test="handleTest"
          />

          <!-- 步骤1: MBTI选择 -->
          <MbtiSelectionComponent
            v-if="currentStep === 1"
            :is-sidebar-collapsed="isSidebarCollapsed"
            @select="handleMbtiSelect"
            @skip="handleSkip"
            @test="handleTest"
            @next="handleMbtiNext"
          />

          <!-- 步骤2: 上传材料 -->
          <UploadContent
            v-if="currentStep === 2"
            :selected-mbti="selectedMbti"
            @back="handleUploadBack"
            @next="handleUploadNext"
            @uploaded="handleResumeUploaded"
          />

          <!-- 步骤3: 聊天 -->
          <ChatInterface
            v-if="currentStep === 3"
            :selected-mbti="selectedMbti"
            :session-id="currentSessionId"
            @back="currentStep = 2"
            @favorite-changed="handleFavoriteChanged"
          />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/index.vue'
import { getUserInfo } from '@/api/user'
import { createSession, getSessionList, newSession } from '@/api/careerPlan'
import WelcomePage from './components/WelcomePage.vue'
import MbtiSelection from './components/MbtiSelection.vue'
import UploadContent from './components/UploadContent.vue'
import ChatInterface from './components/ChatInterface.vue'

export default {
  // 页面本身用不同的 name，避免与子组件冲突导致递归渲染
  name: 'MbtiSelectionPage',
  components: {
    PageHeader,
    WelcomePage,
    MbtiSelectionComponent: MbtiSelection,
    UploadContent,
    ChatInterface
  },
  data() {
    return {
      currentStep: 0, // 当前步骤：0-欢迎页, 1-MBTI选择, 2-上传, 3-聊天
      isSidebarCollapsed: false,
      drawerVisible: false,
      hoverCloseTimer: null,
      keepDrawerOpen: false,
      hasClickedDrawerItem: false, // 标记是否点击了抽屉内的节点
      isClickingIcon: false, // 标记是否正在点击图标
      iconMouseDownTime: 0, // 记录图标 mousedown 的时间
      selectedMbti: null, // 选中的MBTI code
      prevStepBeforeUpload: 1, // 进入上传步骤前的步骤（0: 欢迎页, 1: MBTI）
      resumeUrl: '', // 上传的简历 URL
      currentSessionId: null, // 当前会话 ID
      consultantName: 'Cathy',
      consultantAvatar: 'https://ai-interview.obs.cn-southwest-2.myhuaweicloud.com/image/829eb34f-f1fb-4d01-9491-89f37e54efd2.jpg', // 需要替换为实际头像路径
      currentPage: '',
      islogin: false,
      activeSide: 'seek',
      avatar: '',
      nickname: '',
      activeCollapse: [], // 折叠面板激活的项，默认为空数组（不展开任何面板）
      favoritesList: [], // 收藏列表
      historyList: [], // 历史对话列表
      // 历史对话分页
      historyPage: 1,
      historyPageSize: 10,
      historyTotal: 0,
      historyHasMore: false,
      historyLoading: false,
      // 收藏分页
      favoritesPage: 1,
      favoritesPageSize: 10,
      favoritesTotal: 0,
      favoritesHasMore: false,
      favoritesLoading: false
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
    },
    handleWelcomeSkip() {
      // 从欢迎页直接跳过 MBTI，记录上一步是 0
      this.prevStepBeforeUpload = 0
      this.currentStep = 2
    },
    handleSkip() {
      // 从 MBTI 选择页跳过，记录上一步是 1
      this.prevStepBeforeUpload = 1
      this.currentStep = 2
    },
    handleTest() {
      // MBTI测试逻辑
      this.$message.info('跳转到MBTI测试')
    },
    handleMbtiSelect(code) {
      this.selectedMbti = code || null
    },
    handleMbtiNext() {
      if (!this.selectedMbti) {
        return
      }
      // 正常从 MBTI 选择进入上传页，上一步是 1
      this.prevStepBeforeUpload = 1
      this.currentStep = 2
    },
    handleUploadBack() {
      // 根据记录的前一个步骤返回：0 -> 欢迎页，1 -> MBTI 选择
      const target = this.prevStepBeforeUpload === 0 ? 0 : 1
      this.currentStep = target
    },
    async handleUploadNext() {
      // 检查必要参数
      if (!this.resumeUrl) {
        this.$message.warning('请先上传简历')
        return
      }

      try {
        let response
        let sessionId

        // 判断是否有历史对话数据
        if (this.historyList.length === 0) {
          // 没有历史对话：调用 newSession 接口
          response = await newSession({
            resume_url: this.resumeUrl,
            mbti_type: this.selectedMbti
          })
          // 获取 sessionId（根据后端返回结构调整）
          sessionId = response?.data?.data?.session_id

        } else {
          // 有历史对话：调用 createSession 接口
          response = await createSession({
            resumeUrl: this.resumeUrl,
            mbtiType: this.selectedMbti
          })
          // 获取 sessionId（根据后端返回结构调整）
          sessionId = response?.data?.data?.session_id
        }

        if (sessionId) {
          this.currentSessionId = sessionId
          this.currentStep = 3
        } else {
          this.$message.error('创建会话失败，请重试')
        }
      } catch (error) {
        console.error('创建会话失败:', error)
        this.$message.error(error?.response?.data?.msg || '创建会话失败，请重试')
      }
    },
    handleResumeUploaded(resumeUrl) {
      console.log(resumeUrl, 'resumeUrl')
      // 保存上传的简历 URL
      this.resumeUrl = resumeUrl || ''
    },

    async handleFavoriteChanged() {
      // 等待一小段时间，确保后端数据已更新
      await this.$nextTick()
      // 重新从第一页加载收藏列表
      await this.loadFavoritesList(false)
    },

    /**
     * 加载历史对话列表
     * @param {boolean} loadMore - 是否加载更多（追加数据）
     */
    async loadHistoryList(loadMore = false) {
      if (this.historyLoading) return
      
      // 如果不是加载更多，重置页码和列表
      if (!loadMore) {
        this.historyPage = 1
        this.historyList = []
      }

      this.historyLoading = true
      try {
        const response = await getSessionList({
          favoriteOnly: false,
          page: this.historyPage,
          pageSize: this.historyPageSize
        })
        
        // 根据后端返回结构处理数据
        const result = response?.data?.data
        const list = result?.lists || []
        const total = result?.total || result?.totalCount || 0
        
        if (loadMore) {
          // 追加数据
          this.historyList = [...this.historyList, ...(Array.isArray(list) ? list : [])]
        } else {
          // 替换数据
          this.historyList = Array.isArray(list) ? list : []
        }
        
        this.historyTotal = total
        this.historyHasMore = this.historyList.length < total
        
        // 如果还有更多数据，页码+1，为下次加载更多做准备
        if (this.historyHasMore) {
          this.historyPage += 1
        }
      } catch (error) {
        console.error('加载历史对话列表失败:', error)
        // 不显示错误提示，避免影响用户体验
      } finally {
        this.historyLoading = false
      }
    },

    /**
     * 加载更多历史对话
     */
    async loadMoreHistory() {
      await this.loadHistoryList(true)
    },

    /**
     * 加载收藏列表
     * @param {boolean} loadMore - 是否加载更多（追加数据）
     */
    async loadFavoritesList(loadMore = false) {
      if (this.favoritesLoading) return
      
      // 如果不是加载更多，重置页码和列表
      if (!loadMore) {
        this.favoritesPage = 1
        this.favoritesList = []
      }

      this.favoritesLoading = true
      try {
        const response = await getSessionList({
          favoriteOnly: true,
          page: this.favoritesPage,
          pageSize: this.favoritesPageSize
        })
        
        // 根据后端返回结构处理数据
        const result = response?.data?.data
        const list = result?.lists || []
        const total = result?.total || result?.totalCount || 0
        
        if (loadMore) {
          // 追加数据
          this.favoritesList = [...this.favoritesList, ...(Array.isArray(list) ? list : [])]
        } else {
          // 替换数据
          this.favoritesList = Array.isArray(list) ? list : []
        }
        
        this.favoritesTotal = total
        this.favoritesHasMore = this.favoritesList.length < total
        
        // 如果还有更多数据，页码+1，为下次加载更多做准备
        if (this.favoritesHasMore) {
          this.favoritesPage += 1
        }
      } catch (error) {
        console.error('加载收藏列表失败:', error)
        // 不显示错误提示，避免影响用户体验
      } finally {
        this.favoritesLoading = false
      }
    },

    /**
     * 加载更多收藏
     */
    async loadMoreFavorites() {
      await this.loadFavoritesList(true)
    },
    handleCollapsedNewChat() {
      // 收缩态下点击「新对话」：保持抽屉打开，并触发新对话逻辑
      this.drawerVisible = true
      this.keepDrawerOpen = true
      this.handleNewChat()
    },
    async handleNewChat() {
      // 新对话逻辑
      this.keepDrawerOpen = true

      try {
        const response = await createSession()
        const sessionId = response?.data?.data?.session_id

        if (sessionId) {
          this.currentSessionId = sessionId
          this.currentStep = 3
        } else {
          this.$message.error('创建新会话失败，请重试')
        }
      } catch (error) {
        console.error('创建新会话失败:', error)
        this.$message.error(error?.response?.data?.msg || '创建新会话失败，请重试')
      }
    },
    goToFavorites() {
      // 跳转到我的收藏
      this.keepDrawerOpen = true
    },
    goToHistory() {
      // 跳转到历史对话
      this.keepDrawerOpen = true
    },
    handleFavoriteClick(item) {
      // 点击收藏项，标记已点击抽屉内节点
      this.hasClickedDrawerItem = true
      this.keepDrawerOpen = true
      const sessionId =  item.session_id
      
      if (sessionId) {
        this.currentSessionId = sessionId
        this.currentStep = 3
        this.drawerVisible = false
        this.keepDrawerOpen = false
      } else {
        this.$message.warning('无法获取会话 ID')
      }
    },
    handleHistoryClick(item) {
      // 点击历史对话项，标记已点击抽屉内节点
      this.hasClickedDrawerItem = true
      this.keepDrawerOpen = true
      
      // 获取会话 ID（可能是 id 或 sessionId 字段）
      const sessionId = item.id || item.sessionId || item.session_id
      
      if (sessionId) {
        this.currentSessionId = sessionId
        this.currentStep = 3
        this.drawerVisible = false
        this.keepDrawerOpen = false
      } else {
        this.$message.warning('无法获取会话 ID')
      }
    },
    handleCollapseChange(activeNames) {
      if (this.drawerVisible && activeNames) {
        this.hasClickedDrawerItem = true
      }
    },
    /**
     * 判断历史记录项是否被选中
     */
    isHistoryItemActive(item) {
      if (!item || !this.currentSessionId) return false
      const sessionId = item.id || item.sessionId || item.session_id
      return sessionId === this.currentSessionId
    },
    /**
     * 判断收藏项是否被选中
     */
    isFavoriteItemActive(item) {
      if (!item || !this.currentSessionId) return false
      const sessionId = item.id || item.sessionId || item.session_id
      return sessionId === this.currentSessionId
    },
    handleSwitch(side) {
      this.activeSide = side
    },
    handleLogout() {
      this.islogin = false
      this.avatar = ''
      this.nickname = ''
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$message.success('已退出登录')
    },
    goToFeedback() {
      this.$message.info('跳转到意见反馈')
    },
    async isLogin() {
      try {
        const res = await getUserInfo()
        if (res.data.code === 1) {
          const data = res.data.data || {}
          this.avatar = data.avatar || ''
          this.nickname = data.real_name || data.nickname || ''
          this.islogin = true
        } else {
          this.islogin = false
          this.avatar = ''
          this.nickname = ''
        }
      } catch (e) {
        this.islogin = false
        this.avatar = ''
        this.nickname = ''
      }
    },
    // 图标 hover 处理（阻止冒泡到父元素）
    handleIconEnter(e) {
      e.stopPropagation()
      if (this.isClickingIcon) {
        return
      }
      const timeSinceMouseDown = Date.now() - this.iconMouseDownTime
      if (this.iconMouseDownTime > 0 && timeSinceMouseDown < 200) {
        return
      }
      this.handleCollapsedEnter(e)
    },
    handleIconLeave(e) {
      e.stopPropagation()
      if (this.isClickingIcon) {
        return
      }
    },
    // 抽屉 hover 相关：图标和抽屉任一地方 hover 时保持打开，全部离开一段时间后关闭
    handleCollapsedEnter(e) {
      if (!this.isSidebarCollapsed) {
        return
      }
      
      if (this.isClickingIcon) {
        return
      }
      
      const timeSinceMouseDown = Date.now() - this.iconMouseDownTime
      if (this.iconMouseDownTime > 0 && timeSinceMouseDown < 1000) {
        return
      }
      
      // 检查鼠标是否在图标区域内，如果是则直接展开侧边栏
      if (e && e.clientX !== undefined && e.clientY !== undefined) {
        const iconElement = this.$el.querySelector('.collapsed-icon')
        if (iconElement) {
          const rect = iconElement.getBoundingClientRect()
          const margin = 20
          if (e.clientX >= rect.left - margin && e.clientX <= rect.right + margin && 
              e.clientY >= rect.top - margin && e.clientY <= rect.bottom + margin) {
            this.isSidebarCollapsed = false
            this.drawerVisible = false
            this.isClickingIcon = true
            this.iconMouseDownTime = Date.now()
            setTimeout(() => {
              this.isClickingIcon = false
              this.iconMouseDownTime = 0
            }, 1000)
            return
          }
        }
      }
      
      // 检查 target 和 relatedTarget
      if (e) {
        if (e.target) {
          const isOnIcon = e.target.closest && e.target.closest('.collapsed-icon')
          if (isOnIcon) {
            return
          }
        }
        if (e.relatedTarget) {
          const isFromIcon = e.relatedTarget.closest && e.relatedTarget.closest('.collapsed-icon')
          if (isFromIcon) {
            return
          }
        }
      }
      
      // 打开抽屉
      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }
      this.hasClickedDrawerItem = false
      this.drawerVisible = true
    },
    handleCollapsedLeave() {
      // 延迟关闭，给鼠标移动到抽屉的时间
      this.scheduleHoverClose()
    },
    handleDrawerEnter() {
      // 鼠标进入抽屉，清除关闭定时器
      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }
      // 确保抽屉是打开状态
      if (!this.drawerVisible) {
        this.drawerVisible = true
      }
    },
    handleDrawerLeave(e) {
      // 检查鼠标是否移动到图标区域或仍在抽屉内
      const relatedTarget = e.relatedTarget
      if (relatedTarget) {
        // 检查是否移动到图标
        if (typeof relatedTarget.closest === 'function') {
          const isMovingToIcon = relatedTarget.closest('.collapsed-icon')
          if (isMovingToIcon) {
            // 如果移动到图标，不清除定时器，让图标处理
            return
          }
        }
        // 检查是否仍在抽屉内（可能是移动到抽屉的子元素）
        if (typeof relatedTarget.closest === 'function') {
          const isStillInDrawer = relatedTarget.closest('.mbti-mini-drawer')
          if (isStillInDrawer) {
            // 仍在抽屉内，不关闭
            return
          }
        }
      }
      // 真正离开抽屉区域，延迟关闭
      this.scheduleHoverClose()
    },
    scheduleHoverClose() {
      // 如果点击了抽屉内的节点，不自动关闭
      if (this.hasClickedDrawerItem || this.keepDrawerOpen) {
        return
      }
      // 清除之前的定时器
      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }
      // 增加延迟时间到 500ms，给鼠标更多时间移动到抽屉
      this.hoverCloseTimer = setTimeout(() => {
        // 再次检查是否应该关闭（可能在延迟期间鼠标又进入了或点击了节点）
        // 需要同时检查抽屉是否仍然可见，避免在已经关闭的情况下重复操作
        if (this.drawerVisible && !this.keepDrawerOpen && !this.hasClickedDrawerItem) {
          this.drawerVisible = false
        }
        this.hoverCloseTimer = null
      }, 500) // 增加到 500ms 容错时间，避免抖动
    },
    handleCollapsedMouseDown(e) {
      e.stopPropagation()
      e.preventDefault()
      
      this.iconMouseDownTime = Date.now()
      this.isClickingIcon = true
      this.drawerVisible = false

      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }

      this.keepDrawerOpen = false
      this.hasClickedDrawerItem = false
      
      if (this.isSidebarCollapsed) {
        this.isSidebarCollapsed = false
      }
    },
    handleCollapsedIconClick(e) {
      // 阻止事件冒泡，防止触发父元素的 hover 事件
      e.stopPropagation()
      e.preventDefault() // 阻止默认行为
      // 1. 确保抽屉关闭
      this.drawerVisible = false

      // 2. 清除任何待关闭的定时器
      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }

      // 3. 重置所有相关标记
      this.keepDrawerOpen = false
      this.hasClickedDrawerItem = false

      // 4. 确保侧边栏已展开（如果 mousedown 没有成功，这里作为备用）
      if (this.isSidebarCollapsed) {
        this.isSidebarCollapsed = false
      }
      
      
      // 5. 延迟重置点击标记，确保后续的 hover 事件不会立即触发
      setTimeout(() => {
        this.isClickingIcon = false
        this.iconMouseDownTime = 0
        console.log('[Sidebar] isClickingIcon 已重置，isSidebarCollapsed:', this.isSidebarCollapsed)
      }, 500) // 延迟 500ms 重置，避免立即触发 hover
    },
    handleGlobalClick(e) {
      if (!this.isSidebarCollapsed || !this.drawerVisible) return

      // 抽屉自身会处理点击内部不关闭，我们这里只处理点击页面其他位置时关闭
      const path = e.path || (e.composedPath && e.composedPath()) || []
      const clickedInDrawer = path.some(node => {
        return node && node.classList && node.classList.contains('mbti-mini-drawer')
      })
      // 如果点击的是 collapsed-icon 或 collapsed-new-chat，不关闭抽屉
      const clickedInIcon = path.some(node => {
        return (
          node &&
          node.classList &&
          (node.classList.contains('collapsed-icon'))
        )
      })
      if (!clickedInDrawer && !clickedInIcon) {
        // 点击外部节点时关闭抽屉并重置标记
        this.drawerVisible = false
        this.keepDrawerOpen = false
        this.hasClickedDrawerItem = false
      }
    }
  },
  async created() {
    this.isLogin()

    // 加载历史对话列表和收藏列表
    await this.loadHistoryList()
    this.loadFavoritesList()

    // 如果有历史对话，自动选择最近的一个会话并显示聊天界面
    if (this.historyList.length > 0) {
      const latestSession = this.historyList[0] // 第一个通常是最新的
      const sessionId = latestSession.id || latestSession.sessionId || latestSession.session_id
      
      if (sessionId) {
        this.currentSessionId = sessionId
        this.currentStep = 3
        // 自动展开历史对话面板
        if (this.activeCollapse.indexOf('history') === -1) {
          this.activeCollapse.push('history')
        }
      }
    }

    // 点击页面其他区域时关闭抽屉
    document.addEventListener('click', this.handleGlobalClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>

<style lang="scss" scoped>
.mbti-selection-page {
  display: flex;
  flex-direction: column;
  height: 100vh; // 改为固定高度，避免超出
  background: #ffffff;
  padding-top: 64px; // 为 fixed header 留出空间
  overflow: hidden; // 防止页面级滚动条
}

// 步骤内容区域
.step-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; // 确保flex子元素可以正确收缩
}

.page-layout {
  display: flex;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  height: calc(100vh - 64px); 
  background: linear-gradient(to bottom, #f5f5f5 0%, #ffffff 100%);
  .icon{
    font-size: 20px;
  }
}

.sidebar {
  width: 280px;
  background: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
  flex-shrink: 0;

  &.collapsed {
    width: 80px;
  }
}

.sidebar-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.consultant-section {
  margin-bottom: 20px;
}

.consultant-avatar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background: linear-gradient(90deg, rgba(98, 175, 255, 0.05) 0%, rgba(156, 65, 255, 0.05) 100%);
}

.avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    height: 170%;
    margin-left: -16px;
    object-fit: cover;
  }
}

.avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7EB4EB 0%, #B16EF9 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  flex-shrink: 0;
}

.consultant-info {
  flex: 1;
  min-width: 0;
}

.consultant-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.consultant-name {
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.consultant-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-text {
  font-size: 18px;
}

.sidebar.collapsed .consultant-info,
.sidebar.collapsed .consultant-icon {
  display: none;
}

.sidebar.collapsed .consultant-avatar {
  justify-content: center;
  padding: 8px;
}

.sidebar.collapsed .consultant-section {
  margin-bottom: 16px;
}

.new-chat-btn {
  height: 40px;
  padding: 16px 24px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
}
.new-chat{
  width: 100%
}

.sidebar.collapsed .new-chat-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 0;
}

.sidebar.collapsed .btn-text {
  display: none;
}

.btn-icon {
  font-size: 18px;
  font-weight: 600;
}

// 折叠面板样式
.sidebar-collapse {
  border: none;
  background: transparent;
  margin-top: 20px;

  ::v-deep .el-collapse-item {
    border: none;
    margin-bottom: 8px;
  }

  ::v-deep .el-collapse-item__header {
    padding: 0;
    border-radius: 8px;
    background: transparent;
    font-size: 14px;
    color: #333;
    transition: all 0.2s ease;

    &:hover {
      background: #e9ecef;
    }
  }

  ::v-deep .el-collapse-item__arrow {
    display: none;
  }

  ::v-deep .el-collapse-item__content {
    padding: 0;
    padding-top: 8px;
  }

  ::v-deep .el-collapse-item__wrap {
    border: none;
    background: transparent;
  }
}

.collapse-title {
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;

  .el-icon-star-off {
    font-size: 16px;
    color: #606266;
  }
  .icon{
    font-size: 20px;
  }
}
.collapse-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 12px 8px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  
  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}

.collapse-list-item {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  &.is-active {
    background: #e6f4ff;
    padding-left: 9px;

    .list-item-text {
      color: #7EB4EB;
      font-weight: 500;
    }
  }
}

.list-item-text {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-item-time {
  font-size: 11px;
  color: #999;
}

.collapse-empty {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

.load-more-wrapper {
  padding: 8px 0;
  text-align: center;
}

.load-more-btn {
  padding: 6px 16px;
  font-size: 12px;
  color: #7EB4EB;
  background: transparent;
  border: 1px solid #7EB4EB;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #7EB4EB;
    color: #fff;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.collapsed-strip {
  width: 180px;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 66px;
  background: transparent; // 默认透明
  position: relative; // 确保定位上下文
  z-index: 1001; // 确保整个 strip 在抽屉上方，可以接收事件
  
  // 聊天步骤时背景为白色
  &.is-chat-step {
    background: #fff;
  }
}

.collapsed-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.collapsed-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 20px;
  color: #606266;
  position: relative;
  z-index: 1000; // 确保图标在抽屉上方，可以接收点击事件
  pointer-events: auto; // 确保可以接收所有鼠标事件
  
  img {
    pointer-events: none;
    user-select: none;
  }
}

.collapsed-icon:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.collapsed-new-chat:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}


.toggle-icon {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 40px;
  overflow-y: auto; // 允许内容滚动
  overflow-x: hidden; // 防止横向滚动条
  background: linear-gradient(to bottom, #f5f5f5 0%, #ffffff 100%);
  transition: margin-left 0.3s ease;
  min-width: 0; // 确保flex布局正常
  min-height: 0; // 确保flex子元素可以正确收缩
  max-height: 100%; // 限制最大高度
  position: relative
}

::v-deep .mbti-mini-drawer {
  top: 132px;
  left: 0; 
  height: calc(100vh - 142px);
  z-index: 100; 
}

// 确保抽屉内容区域可以正确接收鼠标事件
::v-deep .mbti-mini-drawer .el-drawer__body {
  padding: 0;
  height: 100%;
  overflow: hidden;
}


// 响应式设计
@media (max-width: 768px) {
  .main-content {
    padding: 20px;
  }

  .steps-container {
    padding: 0 20px;
  }
}

@media (max-width: 480px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 60px;
    height: calc(100vh - 60px);
    z-index: 200;
    transform: translateX(0);
    transition: transform 0.3s ease;

    &.collapsed {
      transform: translateX(-100%);
    }
  }

  .main-content {
    margin-left: 0;
  }
}
</style>


